import { siteConfig } from '@/configs/siteConfig';

import { siteState } from '@/modules/siteState/siteStateGetter';

const props = {
  className: 'js-megamenu',
  delayTime: 400,
} as const;

const state = {
  els: Array.from(document.querySelectorAll(`.${props.className}`)),
  timeoutId: null as ReturnType<typeof setTimeout> | null,
  activeEl: null as HTMLElement | null,

  mouseenter: {
    handler: undefined as ((e: MouseEvent) => void) | undefined,
  },

  mouseleave: {
    handler: undefined as ((e: MouseEvent) => void) | undefined,
  },
};

export const megamenuManager = {
  init() {
    if (siteState.isHover) {
      this.mouseenter();
      this.mouseleave();
    }
  },

  reset() {
    this.removeMouseenter();
    this.removeMouseleave();
  },

  mouseenter() {
    if (state.mouseenter.handler) return;

    state.mouseenter.handler = (e: MouseEvent) => {
      const targetEl = e.target;
      const related = e.relatedTarget as Node | null;

      if (!(targetEl instanceof HTMLElement)) return;

      const parent = state.els.find((el) => el === targetEl);
      if (!parent) return;

      if (related && parent.contains(related)) return;

      this.mouseenterHandler(targetEl);
    };

    document.addEventListener('mouseenter', state.mouseenter.handler, true);
  },

  mouseenterHandler(el: HTMLElement) {
    // 遅延削除タイマーがあればキャンセル
    if (state.timeoutId) {
      clearTimeout(state.timeoutId);
      state.timeoutId = null;
    }

    // 既に別の要素がアクティブならクラス削除
    if (state.activeEl && state.activeEl !== el) {
      state.activeEl.classList.remove(siteConfig.class.act);
    }

    // 新しい要素をアクティブに
    state.activeEl = el;
    el.classList.add(siteConfig.class.act);
  },

  removeMouseenter() {
    if (!state.mouseenter.handler) return;

    document.removeEventListener('mouseenter', state.mouseenter.handler, true);
    state.mouseenter.handler = undefined;
  },

  mouseleave() {
    if (state.mouseleave.handler) return;

    state.mouseleave.handler = (e: MouseEvent) => {
      const targetEl = e.target;
      const related = e.relatedTarget as Node | null;

      if (!(targetEl instanceof HTMLElement)) return;

      const parent = state.els.find((el) => el === targetEl);
      if (!parent) return;

      if (related && parent.contains(related)) return;

      this.mouseleaveHandler(targetEl);
    };

    document.addEventListener('mouseleave', state.mouseleave.handler, true);
  },

  mouseleaveHandler(el: HTMLElement) {
    // 遅延削除タイマーを設定
    state.timeoutId = setTimeout(() => {
      el.classList.remove(siteConfig.class.act);
      state.activeEl = null;
      state.timeoutId = null;
    }, props.delayTime);
  },

  removeMouseleave() {
    if (!state.mouseleave.handler) return;

    document.removeEventListener('mouseleave', state.mouseleave.handler, true);
    state.mouseleave.handler = undefined;
  },
};
